import React, { useState } from "react";
import { deleteBusApi } from "../../../../apis/bus.api";
import { IBusDetail, ITripDetail } from "../../../../models/trip";
import { ErrorPopup } from "../../../../utilities/swal";
import { Button, Modal } from "antd";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonRemoveBusProps {
  onSetTrip: React.Dispatch<React.SetStateAction<ITripDetail | null>>;
  bus: IBusDetail;
}

const ButtonRemoveBus: React.FC<ButtonRemoveBusProps> = (
  props: ButtonRemoveBusProps
) => {
  const { bus, onSetTrip } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    if (loading) return;
    setIsModalOpen(false);
  };  useModalLockScroll(isModalOpen);
  const handleDeleteBus = async () => {
    try {
      setLoading(true);
      const rs = await deleteBusApi(bus._id);
      if (rs && rs.success) {
        onSetTrip((prev) => {
          if (!prev) return prev; // không có trip thì giữ nguyên

          return {
            ...prev,
            buses: prev.buses.filter((bus) => bus._id !== rs?.data._id),
          };
        });
      } else {
        ErrorPopup("Xóa xe thất bại", rs?.message || "");
      }

      setLoading(false);
      setIsModalOpen(false);
    } catch (error: any) {
      ErrorPopup("Xóa xe thất bại", error?.message || "");
    }
  };
  return (
    <div>
      <Button  danger onClick={showModal} className="font-medium w-full">
        Xóa xe
      </Button>

      <Modal
        title={`Xác nhận xóa xe số ${bus.busNumber} `}
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleDeleteBus}
        okText="Xóa"
        cancelText="Hủy"
        okButtonProps={{ danger: true, loading }}
        cancelButtonProps={{ disabled: loading }}
      >
        <p>Bạn có chắc chắn muốn xóa xe {bus.busNumber} không?</p>
      </Modal>
    </div>
  );
};

export default ButtonRemoveBus;
